export const COMPLAINTS_API_ERROR = "COMPLAINTS_API_ERROR";
export const API_ERROR = "API_ERROR";

export type ActionPayload = {
  type: string;
  payload: any;
};
